export interface Config {
  apiUrl: string;
  environment: 'development' | 'staging' | 'production';
  enableDevTools: boolean;
  isDevelopment: boolean;
  isProduction: boolean;
}

const config: Config = {
  apiUrl: import.meta.env.VITE_API_URL || '/api',
  environment: (import.meta.env.VITE_ENVIRONMENT as Config['environment']) || 'development',
  enableDevTools: import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true' || import.meta.env.DEV,
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};

export default config;